const ENV_DEV = 'development'
const ENV_PRODUCTION = 'production'

module.exports = {
  uploadUrl: 'https://apps.daishutijian.com/traceerror', // 打点服务器，或Nginx地址' 服务器上传地址
  version: '2.2.7', // 版本号
  build: {
    bundleAnalyzerReport: false,
    env: ENV_PRODUCTION
  },
  dev: {
    bundleAnalyzerReport: false,
    env: ENV_DEV
  }
}
